// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MeFragmentDoc } from '../../graphql/api/fragments/me.fragment.generated';
import { CostumerConsultantFragmentDoc } from '../../graphql/api/fragments/costumerConsultant.fragment.generated';
import { TranslationFragmentDoc } from '../../graphql/api/fragments/translation.fragment.generated';
import { TopBarFragmentDoc } from '../../components/layout/header/menu/api/TopBar.fragment.generated';
import { TopBarSiteWideMessageFragmentDoc } from '../../components/layout/header/menu/api/TopBarSiteWideMessage.fragment.generated';
import { LinkFragmentDoc, LinkItemFragmentDoc, PageLinkFragmentDoc, PostLinkFragmentDoc, CustomLinkFragmentDoc, LinkQuestionnaireFragmentDoc, LinkItemOpenEnquiryFormFragmentDoc, LinkItemErRecommendationsFragmentDoc } from '../../components/cms/index.generated';
import { TopBarConsultationPromptFragmentDoc } from '../../components/layout/header/menu/api/TopBarConsultationPrompt.fragment.generated';
import { PreHeaderFragmentDoc } from '../../components/layout/header/menu/api/PreHeader.fragment.generated';
import { HeaderMenuFragmentDoc } from '../../components/layout/header/menu/api/HeaderMenu.fragment.generated';
import { SubMenuFragmentDoc } from '../../components/layout/header/menu/api/SubMenu.fragment.generated';
import { SubMenuSectionFragmentDoc } from '../../components/layout/header/menu/api/SubMenuSection.fragment.generated';
import { SubMenuItemFragmentDoc } from '../../components/layout/header/menu/api/SubMenuItem.fragment.generated';
import { ImageLargeFragmentDoc } from '../../components/cms/imageLarge.fragment.generated';
import { ImageCommonFragmentDoc } from '../../components/cms/imageCommon.fragment.generated';
import { ImageSizeFragmentDoc } from '../../components/cms/imageSize.fragment.generated';
import { SubMenuEditorialContentFragmentDoc } from '../../components/layout/header/menu/api/SubMenuEditorialContent.fragment.generated';
import { SocialNetworkFragmentDoc } from '../../graphql/api/fragments/socialNetworks.fragment.generated';
import { PaymentIconFragmentDoc } from '../../graphql/api/fragments/paymentIcon.fragment.generated';
import { FooterFragmentDoc } from '../../components/layout/footer/Footer.fragment.generated';
import { FooterMenuFragmentDoc } from '../../components/layout/footer/FooterMenu.fragment.generated';
import { FooterMenuItemFragmentDoc } from '../../components/layout/footer/FooterMenuItem.fragment.generated';
import { FooterItemTitleFragmentDoc } from '../../components/layout/footer/FooterItemTitle.fragment.generated';
import { FooterItemLinkListFragmentDoc } from '../../components/layout/footer/FooterItemLinkList.fragment.generated';
import { FooterItemTextFragmentDoc } from '../../components/layout/footer/FooterItemText.fragment.generated';
import { FooterItemDividerFragmentDoc } from '../../components/layout/footer/FooterItemDivider.fragment.generated';
import { FooterItemWorkingHoursFragmentDoc } from '../../components/layout/footer/FooterItemWorkingHours.fragment.generated';
import { WorkingHoursFragmentDoc } from '../../components/cms/WorkingHours.fragment.generated';
import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export const EnquiryFormContentFragmentDoc = `
    fragment enquiryFormContent on EnquiryFormContent {
  slug
  title
  description
  buttonText
}
    `;
export const InitDocument = `
    query init($locale: Locale!, $isConsultant: Boolean!) {
  me {
    ...me
  }
  workingHours(locale: $locale) {
    weekDays
    opening
    closing
  }
  language(locale: $locale) {
    locale
    translations {
      ...translation
    }
  }
  topBar(locale: $locale) {
    ...topBar
  }
  preHeader(locale: $locale) {
    ...preHeader
  }
  mainMenu(locale: $locale) {
    ...headerMenu
  }
  socialNetworks(locale: $locale) {
    ...socialNetwork
  }
  paymentIcons(locale: $locale) {
    ...paymentIcon
  }
  footer(locale: $locale) {
    ...footer
  }
  enquiryFormContents(locale: $locale) {
    ...enquiryFormContent
  }
}
    ${MeFragmentDoc}
${CostumerConsultantFragmentDoc}
${TranslationFragmentDoc}
${TopBarFragmentDoc}
${TopBarSiteWideMessageFragmentDoc}
${LinkFragmentDoc}
${LinkItemFragmentDoc}
${PageLinkFragmentDoc}
${PostLinkFragmentDoc}
${CustomLinkFragmentDoc}
${LinkQuestionnaireFragmentDoc}
${LinkItemOpenEnquiryFormFragmentDoc}
${LinkItemErRecommendationsFragmentDoc}
${TopBarConsultationPromptFragmentDoc}
${PreHeaderFragmentDoc}
${HeaderMenuFragmentDoc}
${SubMenuFragmentDoc}
${SubMenuSectionFragmentDoc}
${SubMenuItemFragmentDoc}
${ImageLargeFragmentDoc}
${ImageCommonFragmentDoc}
${ImageSizeFragmentDoc}
${SubMenuEditorialContentFragmentDoc}
${SocialNetworkFragmentDoc}
${PaymentIconFragmentDoc}
${FooterFragmentDoc}
${FooterMenuFragmentDoc}
${FooterMenuItemFragmentDoc}
${FooterItemTitleFragmentDoc}
${FooterItemLinkListFragmentDoc}
${FooterItemTextFragmentDoc}
${FooterItemDividerFragmentDoc}
${FooterItemWorkingHoursFragmentDoc}
${WorkingHoursFragmentDoc}
${EnquiryFormContentFragmentDoc}`;

export function useInitQuery(options?: Omit<Urql.UseQueryArgs<never, SchemaTypes.InitQueryVariables | undefined>, 'query'>) {
  return Urql.useQuery<SchemaTypes.InitQuery, SchemaTypes.InitQueryVariables | undefined>({ query: InitDocument, variables: undefined, ...options });
};